export const COMPETITION_BADGE_COUNT = 10;

export const TIER_ORDER = ["starter", "early", "mid", "high", "elite"];

export const TIER_PICKS: Record<string, number> = {
  starter: 1,
  early: 2,
  mid: 2,
  high: 3,
  elite: 2,
};

export function shuffleArray<T>(arr: T[]): T[] {
  const shuffled = [...arr];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export function pickTieredBadges<T extends { stepThreshold: number; tier: string }>(
  allBadges: T[],
  maxThreshold?: number,
): T[] {
  const byTier = new Map<string, T[]>();
  for (const badge of allBadges) {
    if (maxThreshold && badge.stepThreshold > maxThreshold) continue;
    const list = byTier.get(badge.tier) ?? [];
    list.push(badge);
    byTier.set(badge.tier, list);
  }

  const picked: T[] = [];
  for (const tier of TIER_ORDER) {
    const eligible = byTier.get(tier) ?? [];
    if (eligible.length === 0) continue;
    const shuffled = shuffleArray(eligible);
    const count = Math.min(TIER_PICKS[tier] ?? 0, eligible.length);
    for (let i = 0; i < count; i++) {
      picked.push(shuffled[i]);
    }
  }
  return picked.sort((a, b) => a.stepThreshold - b.stepThreshold);
}
